import React, { useState } from 'react';
import { View, Image, ActivityIndicator } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';

import { getTemplate, isWordItem } from '@/api/services/templates';
import { Icon } from '@/components/Icon';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import { Button } from '@/components/ui/therapist/Button';
import { Modal } from '@/components/ui/therapist/Modal';
import { Text } from '@/components/ui/therapist/Text';
import colors from '@/config/colors';
import { toWebAssetUrl } from '@/utils/webAssetUrl';

import { TemplateItem } from './types';
import { styles } from './styles';

type TemplateDetailsModalProps = {
  id: string;
  name: string;
};

export const TemplateDetailsModal = ({
  id,
  name,
}: TemplateDetailsModalProps) => {
  const [openDetailModal, setOpenDetailModal] = useState<boolean>(false);
  const [templateDetails, setTemplateDetails] = useState<TemplateItem[] | null>(
    null,
  );

  const handleSeeDetails = async () => {
    setOpenDetailModal(true);

    const { items = [] } = await getTemplate(id);
    setTemplateDetails(items);
  };

  const renderTemplateItem = (item: TemplateItem, index: number) => {
    const object = isWordItem(item) ? item.word : item.sentence;
    return (
      <View
        key={index}
        style={[styles.itemRow, index !== 0 ? styles.itemRowBorder : null]}
      >
        <Image
          resizeMode="contain"
          style={styles.itemImage}
          source={{
            uri: toWebAssetUrl(object?.pictures[0].appimage_url as string),
          }}
        />
        <Text> {object?.print}</Text>
      </View>
    );
  };

  return (
    <>
      <PressableNeolexon
        onPress={handleSeeDetails}
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: 4,
        }}
      >
        <Icon name="eye" size={16} />
        <Text>Vorschau</Text>
      </PressableNeolexon>
      <Modal
        title={name}
        isVisible={openDetailModal}
        confirmActionButton={
          <Button
            label="Schließen"
            look="secondary"
            onPress={() => setOpenDetailModal(false)}
          />
        }
        onClose={() => setOpenDetailModal(false)}
      >
        <ScrollView style={{ minWidth: 500 }}>
          {templateDetails ? (
            templateDetails.map((item, index) =>
              renderTemplateItem(item, index),
            )
          ) : (
            <ActivityIndicator
              size="large"
              color={colors.newUI.therapist.primaryBlue80}
            />
          )}
        </ScrollView>
      </Modal>
    </>
  );
};
